export function queryByHose(diaIDsWithInfo, db, options) {
    const { maxSphereSize, atomLabel } = options;
    const results = [];
    for (let i = 0; i < diaIDsWithInfo.length; i++) {
        const entry = diaIDsWithInfo[i];
        if (atomLabel && entry.atomLabel !== atomLabel)
            continue;
        let res;
        let level = null;
        for (let k = maxSphereSize; k >= 0; k--) {
            if (db[k]?.[entry.hoses[k]]) {
                res = db[k][entry.hoses[k]];
                level = k;
                break;
            }
        }
        const result = {
            diaIDs: [entry.idCode],
            delta: res ? res[0] : null,
            atoms: [i],
            nbAtoms: 1,
            level,
            statistic: res && res.length > 1 // only if DB contains statistics
                ? {
                    mean: res[1],
                    sd: res[2],
                    min: res[3],
                    max: res[4],
                    nb: res[5],
                }
                : undefined,
        };
        results.push(result);
    }
    return results;
}
//# sourceMappingURL=queryByHOSE.js.map